import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const Language = () => {
  const homeMenu = [
    {
      label: "Curriculum",
      link: "",
      subMenu: [
        { label: "Primary Wing", link: "/primarywing" },
        { label: "Middle Wing", link: "/middleWing" },
        { label: "Senior Wing", link: "/seniorWing" },
        { label: "Curriculum", link: "/curriculum" },
      ],
    },

    {
      label: "Extended Classroom",
      link: "",
      subMenu: [
        { label: "Labs", link: "/mathmatics" },
        { label: "Excursions", link: "/excursions" },
        { label: "Library", link: "/library" },
        { label: "Field Trips", link: "/feildTrip" },
        { label: "Astronomy", link: "/astronomy" },
      ],
    },
    {
      label: "Sports",
      link: "",
      subMenu: [
        { label: "Sports", link: "/sports" },
        {
          label: "Achievements in Sports 2022-23",
          link: "/acheivementInSports",
        },
      ],
    },
    {
      label: "Arts",
      link: "",
      subMenu: [
        { label: "Performing Arts", link: "/music" },
        { label: "Visual Arts", link: "/visualArts" },
      ],
    },

    { label: "Houses", link: "/houses" },
    { label: "Assembly", link: "/assembly" },
    { label: "Book List", link: "/booklist" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/learning-app.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Facilities"
                breadEnd="Learning Approach"
                breadMid="Language Lab"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xl-12 mb-4">
              <h4 className="color-red">Language</h4>
              <div class="lab-heading mb-4">
                <div class="lab-btn" id="mb-lab-btn">
                  <span>Labs</span>
                </div>
                <ul class="labs-list">
                  <li>
                    <a class="" href="/mathmatics">
                      Mathematics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/physics">
                      Physics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/biology">
                      Biology
                    </a>
                  </li>
                  <li>
                    <a class="" href="/chemistry">
                      Chemistry
                    </a>
                  </li>
                  <li>
                    <a class="inc-tlink-active" href="/language">
                      Language
                    </a>
                  </li>
                  <li>
                    <a class="" href="/computer">
                      Computer
                    </a>
                  </li>
                  <li>
                    <a class="" href="/robotics">
                      Robotics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/hands-on-studio">
                      Hands On Studio
                    </a>
                  </li>
                  <li>
                    <a class="" href="/psychology">
                      Psychology
                    </a>
                  </li>
                  <li>
                    <a class="" href="/counseling-sen">
                      Counseling &amp; Sen{" "}
                    </a>
                  </li>
                </ul>
              </div>
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/language-lab.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                We at Lotus Valley believe in giving a Global Exposure to our
                students and make them reach the targets in their life
                .Therefore, we take pride in announcing that we are currently
                working on a joint venture with <b>Max Mueller Bhavan</b>/Goethe
                Institute, Delhi on a project.Under this project the students
                are given a vast exposure to the German language,culture and
                tradition.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Language;
